export  function formateDate(loc,datetoFormate){
  if(loc!==null && datetoFormate!== null){
    loc=loc.split('_').join('-');
    let d = new Date(datetoFormate)
    let opt = {  year: 'numeric', month: 'short', day: 'numeric' };
    return d.toLocaleDateString(loc, opt);
  }
  
}
export function formateRCIPoints(loc,num){
  if(loc!==null && num!== null){
    return new Intl.NumberFormat(loc.split('_').join('-')).format(num);
  }
}

export const SearchApiDateFormate=(datetoFormate)=>{

  var d = new Date(datetoFormate);

  return  d.getFullYear() + "-" + (d.getMonth()+1) + "-" + d.getDate();

}

export function searchDateFormatter(calDate) {
  var d = new Date(calDate);
  var day = d.getDate();
  var month = d.getMonth() + 1;
  var year = d.getFullYear();
  if (day < 10) {
      day = "0" + day
  }
  if (month < 10) {
      month = "0" + month
  }
  var date = year + "-" + month + "-" + day;
  return date
}

export const teamSiteUrlFormate=(tscontentUrl)=>{
  if (tscontentUrl.indexOf("/sites/") > -1) {
       return tscontentUrl.replace("/sites/", "/");
  }else {
    return tscontentUrl;
  }
}
export  function NBAformateDate(loc,datetoFormate){
  if(loc && datetoFormate){
    datetoFormate=datetoFormate.split('-').join('/')
    loc=loc.split('_').join('-');
    let d = new Date(datetoFormate)
    let opt = {  year: 'numeric', month: 'short', day: 'numeric' };
    return d.toLocaleDateString(loc, opt);
  }
  
}

export function nameFormate (custName) {
  if(custName){
    return custName.charAt(0).toUpperCase() + custName.slice(1).toLowerCase();
  }else{
    return "";
  }
  
}

export function dateFormateMMddyyyy(dateToFormate){
  if( dateToFormate!== null){
    dateToFormate=dateToFormate.split('-').join('/')
   
   let d = new Date(dateToFormate)
   let formatedDate=d.getDate();
   let  formatedMonth=d.getMonth()+1;
   let  formatedYear=d.getFullYear();

    return formatedMonth+'/'+formatedDate+'/'+formatedYear
  }
}




export const getCalDurationEnd = () => {
  let date = new Date();
  date.setFullYear(date.getFullYear() + 2);
  return date;
}